/**
 * @file 问答常量
 * @author zhanghaohan
 */

// 互动问答excel模板地址
export const FAQ_EXCEL_TEMPLATE = 'https://huibo-data.cdn.bcebos.com/upload/b8504d77054073a1e198d5bf34d066c3.vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const FAQ_AUDIT_PROMPT_MAP = {
    1: '字数超限，请修改。',
    2: '内容涉嫌敏感词，请修改。',
    3: '与现有文字重复，请修改。',
    4: '可能涉及平台违规，请调整后再试',
    5: '可能涉及极限词违规，请调整后再试'
};
export const PPT_STATUS_MAP = {
    VIOLATE: 'reject',
    SENSITIVE: 'review'
};
export const PPT_STATUS_MAP_ERROR = {
    [PPT_STATUS_MAP.VIOLATE]: '图片可能涉及违规内容，请点击底部按钮重新上传。',
    [PPT_STATUS_MAP.SENSITIVE]: '图片可能涉及敏感内容，请点击底部按钮重新上传。'
};
export const FAQ_UPDATE_POPOVER = 'faq_update_popover';
export const FAQ_MERGE_POPOVER = 'faq_merge_popover';
export const FAQ_CREATE_POPOVER = 'faq_create_popover';